export const FileUploadType = {
  '.doc': 'Word',
  '.pdf': 'PDF',
  '.jpg': 'JPG',
  '.jpeg': 'JPG',
  '.png': 'PNG',
  '.xls': 'Excel',
  '.csv': 'CSV',
};
